import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { iFullStoreState } from '../../../shared/interfaces'
import { IMinimalDevice } from '../LoanerVehicles'

import { DevicesDetailsContainer } from '../../../stores/reducers/devicesData'

import { is } from 'immutable'

export const useDevices = () => {
  const devices = useSelector<iFullStoreState, DevicesDetailsContainer>(
    (s) => s.devicesData.devicesDetails,
    is
  )

  const devicesArray = devices.valueSeq().toArray()

  const availableDevices: IMinimalDevice[] = useMemo(
    () => devicesArray
      .filter((device) => device && device.name)
      .map((device) => ({
        id: device.id,
        name: device.name,
      })),
    [devicesArray]
  )

  return {
    devices: devicesArray,
    availableDevices,
  }
}
